import { render, staticRenderFns } from "./photoScan.vue?vue&type=template&id=3c1fbd2a&scoped=true"
import script from "./photoScan.vue?vue&type=script&lang=js"
export * from "./photoScan.vue?vue&type=script&lang=js"
import style0 from "./photoScan.vue?vue&type=style&index=0&id=3c1fbd2a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1fbd2a",
  null
  
)

export default component.exports